import React, { FC } from 'react';
import { Button, EmptyListWarning, Grid, Icon, Row } from '../../components';
import { dateTimeFormat } from '../../constants/date-format';
import moment from 'moment';
import { ExpertArea } from 'models/expert-certificates';

interface Props {
    data: ExpertArea[];
    setUpdate: (val: ExpertArea) => void;
    onDelete: (val: string) => void;
}

export const AreasGrid: FC<Props> = ({ data, setUpdate, onDelete }) => {
    const getGridData = (): Row[] =>
        data.map((item) => ({
            ...item,
            creationDate: moment(item.creationDate).format(dateTimeFormat),
            deleteActions: {
                additionalComponent: (
                    <Button pSize="none" handleClick={() => onDelete(item.id)}>
                        <Icon iconName="delete" />
                    </Button>
                ),
            },
            updateActions: {
                additionalComponent: (
                    <Button pSize="none" handleClick={() => setUpdate(item)}>
                        <Icon iconName="edit" />
                    </Button>
                ),
            },
        }));
    return data.length ? <Grid columns={getColumns()} rows={getGridData()} /> : <EmptyListWarning />;
};

const getColumns = () => ({
    id: {
        value: 'Id',
        columnSize: '20',
    },
    creationDate: {
        value: 'Дата создания',
        columnSize: '20',
    },
    name: {
        value: 'Название',
        columnSize: '30',
    },
    updateActions: {
        value: '',
        columnSize: '10',
    },
    deleteActions: {
        value: '',
        columnSize: '10',
    },
});
